"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSkeletonWrapper = void 0;
var tslib_1 = require("tslib");
var asg_1 = require("@alinta-digital/asg");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
exports.StyledSkeletonWrapper = (0, styled_components_1.default)(asg_1.Box)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  line-height: ", "};\n"], ["\n  line-height: ", "};\n"])), function (_a) {
    var l = _a.lineHeight;
    return l !== null && l !== void 0 ? l : '1';
});
var templateObject_1;
//# sourceMappingURL=SkeletonWrapper.styles.js.map